import * as Sentry from '@sentry/react'

const isDevelopment = process.env.NODE_ENV === 'development'

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    // Tracing
    tracesSampleRate: isDevelopment ? 1.0 : 0.1, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        'localhost',
        'https://api.dimediacrm.com/api/',
        'https://api.demo-crm.dimedianekretnine.com/api/',
        'https://api.dmn-app.dimedianekretnine.com/api/',
        'https://api.dev-app.dimedianekretnine.com/api/',
    ],
    // Session Replay
    replaysSessionSampleRate: isDevelopment ? 1.0 : 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})
